/* --------------------------------------------------------------------------------------
   preview.component.js

   Copyright © 2019 Xerox Corporation. All Rights Reserved.
   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const previewComponent = {
  template: require("./preview.html"),
  bindings: {
    file: "<",
  },
  controllerAs: "vm",
  controller: class previewCtrl {
    /*@ngInject*/
    constructor(commonService, apiClientService, printModuleService) {
      this.commonService = commonService;
      this.apiClientService = apiClientService;
      this.printModuleService = printModuleService;
    }

    async $onChanges() {
      //TODO: PrintModuleService should not be instanced from here, find a way to split
      if (this.file) {
        this.show = true;
        const ticketGuid = this.commonService.getNewGuid();
        const ticket = await this.printModuleService.getPrintTicket(
          ticketGuid,
          this.file.ID
        );
        this.previewData = await this.printModuleService.getPrintPreview(
          ticketGuid
        );
        this.imageURL = this.previewData.PreviewUrl;
        this.commonService.updateView();
      }
    }

    close() {
      this.show = false;
      this.previewData = null;
      this.imageURL = null;
      this.commonService.updateView();
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/browser/components/preview.component.js